module.exports = __webpack_public_path__ + "static/media/anteater.17bc8863.jpg";